/**
 * RAD Truck Straps — rad-fitment-data.js
 * Vehicle compatibility data for the fitment finder.
 *
 * MAINTENANCE:
 *   Edit this file when adding new vehicle compatibility.
 *   Upload to Admin > Content > Files and link from theme.liquid
 *   (or inline in the section — see rad-fitment-finder.liquid).
 *
 * STRUCTURE:
 *   RAD_FITMENT[make][model] = {
 *     years:   [min, max]  — inclusive year range
 *     type:    'boxlink' | 'universal'
 *     note:    string — shown in the confirmation panel
 *     handle:  Shopify product handle to link Add to Cart toward
 *     variantHint: string — pre-selects this variant label (optional)
 *   }
 *
 * TYPES:
 *   boxlink   — direct BoxLink replacement, no drilling
 *   universal — Universal Plate required
 *   no-fit    — not currently compatible (shows contact CTA)
 */

window.RAD_FITMENT = {

  /* ─── FORD ──────────────────────────────────────────────────── */
  'Ford': {
    'F-150': {
      years: [2015, 2025],
      type: 'boxlink',
      note: 'Direct BoxLink replacement. Bolts into existing anchor points. No drilling required. 15-minute install.',
      handle: 'rad-truck-straps-ford-f150',
      variantHint: 'Ford F-150 BoxLink'
    },
    'F-250 Super Duty': {
      years: [2017, 2025],
      type: 'boxlink',
      note: 'Direct BoxLink replacement for F-250 Super Duty. Handles heavy-haul loads. DOT-certified rated system.',
      handle: 'rad-truck-straps-ford-f150',
      variantHint: 'Ford F-250 BoxLink'
    },
    'F-350 Super Duty': {
      years: [2017, 2025],
      type: 'boxlink',
      note: 'Direct BoxLink replacement for F-350 Super Duty. Built for the heaviest work truck loads.',
      handle: 'rad-truck-straps-ford-f150',
      variantHint: 'Ford F-350 BoxLink'
    },
    'Ranger': {
      years: [2019, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Uses existing bolt points in the Ranger bed rails.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Maverick': {
      years: [2022, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Fits Maverick bed rail tie-down points.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    }
  },

  /* ─── CHEVROLET ─────────────────────────────────────────────── */
  'Chevrolet': {
    'Silverado 1500': {
      years: [2014, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Mounts to Silverado bed rail anchor points.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Silverado 2500 HD': {
      years: [2015, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Heavy-duty anchor points in the 2500 HD bed.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Colorado': {
      years: [2015, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Fits Colorado bed rail tie-down loops.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    }
  },

  /* ─── RAM ───────────────────────────────────────────────────── */
  'Ram': {
    '1500': {
      years: [2009, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Mounts to RAM 1500 bed rail tie-down anchors.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    '2500': {
      years: [2010, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. RAM 2500 heavy-duty bed anchors.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    '3500': {
      years: [2010, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Built for the RAM 3500 worksite.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    }
  },

  /* ─── GMC ───────────────────────────────────────────────────── */
  'GMC': {
    'Sierra 1500': {
      years: [2014, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Mounts to Sierra bed rail anchor points.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Sierra 2500 HD': {
      years: [2015, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Heavy-duty fit for the Sierra 2500 HD.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Canyon': {
      years: [2015, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Fits Canyon bed rail tie-down loops.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    }
  },

  /* ─── TOYOTA ────────────────────────────────────────────────── */
  'Toyota': {
    'Tacoma': {
      years: [2016, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Mounts to Tacoma deck rail anchor points.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    },
    'Tundra': {
      years: [2022, 2025],
      type: 'universal',
      note: 'Compatible via Universal Plate. Fits Tundra (3rd gen) bed rail tie-downs.',
      handle: 'rad-truck-straps-universal',
      variantHint: 'Universal Plate'
    }
  }

};

/**
 * Helper: get all makes in display order
 */
window.RAD_FITMENT_MAKES = ['Ford', 'Chevrolet', 'Ram', 'GMC', 'Toyota'];

/**
 * Helper: generate year array between min and max, descending
 */
window.radFitmentYears = function(min, max) {
  var years = [];
  for (var y = max; y >= min; y--) {
    years.push(y);
  }
  return years;
};